const LOCAL_API_URLS = ['http://localhost:3010'];
// new.ukiu.uz serveri API ni o'z domenida /api va /uploads orqali beradi (proksi).
// api.new.ukiu.uz uchun DNS yozuvi yo'q - u faqat REACT_APP_API_URL da aniq berilsa ishlatiladi.
const CUSTOM_DOMAIN_API_URL = 'https://new.ukiu.uz';

function normalizeApiUrl(value = '') {
  const normalized = String(value || '').trim().replace(/\/$/, '');

  if (/^https?:\/\/(localhost|127\.0\.0\.1):4000$/i.test(normalized)) {
    return 'http://localhost:3010';
  }

  return normalized;
}

function dedupeUrls(items = []) {
  return Array.from(new Set(items.map(normalizeApiUrl).filter(Boolean)));
}

function parseApiUrls(value = '') {
  return String(value || '')
    .split(',')
    .map((item) => normalizeApiUrl(item))
    .filter(Boolean);
}

function isLocalApiUrl(url = '') {
  try {
    return ['localhost', '127.0.0.1', '[::1]', '0.0.0.0'].includes(new URL(url).hostname);
  } catch {
    return false;
  }
}

export function resolveApiBaseUrls(configuredUrls = [], location = typeof window === 'undefined' ? undefined : window.location) {
  const hostname = String(location?.hostname || 'localhost').toLowerCase();
  const isLocalSite = ['localhost', '127.0.0.1', '[::1]', '0.0.0.0'].includes(hostname);
  const configured = dedupeUrls(configuredUrls).filter((url) => !url.includes('mock-data-api-nextjs.vercel.app'));
  if (isLocalSite) return configured.length
    ? (configured.some(isLocalApiUrl) ? dedupeUrls([...configured, ...LOCAL_API_URLS]) : configured)
    : LOCAL_API_URLS;

  // A production build can inherit a developer's .env. Never make visitors
  // wait for a request to their own localhost before contacting the real API.
  const publicUrls = configured.filter((url) => !isLocalApiUrl(url));
  if (publicUrls.length) return publicUrls;
  return hostname === 'new.ukiu.uz' || hostname.endsWith('.new.ukiu.uz')
    ? [CUSTOM_DOMAIN_API_URL]
    : [location.origin];
}

const configuredApiUrls = parseApiUrls(process.env.REACT_APP_API_URL);

function buildQueryString(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    searchParams.set(key, String(value));
  });

  return searchParams.toString();
}

export const API_BASE_URL_CANDIDATES = resolveApiBaseUrls(configuredApiUrls);

export const API_BASE_URL = API_BASE_URL_CANDIDATES[0] || LOCAL_API_URLS[0];

export const API_ENDPOINTS = Object.freeze({
  contentRevision: () => '/api/content/__revision',
  contentList: (resource, query = {}) =>
    `/api/content/${resource}?${buildQueryString({
      activeOnly: true,
      imageMode: 'separate',
      summaryOnly: true,
      compact: true,
      ...query
    })}`,
  contentTree: (resource, query = {}) =>
    `/api/content/${resource}/tree?${buildQueryString({
      activeOnly: true,
      navigationOnly: true,
      imageMode: 'separate',
      compact: true,
      ...query
    })}`,
  contentItem: (resource, id, query = {}) =>
    `/api/content/${resource}/${id}?${buildQueryString({
      imageMode: 'separate',
      compact: true,
      ...query
    })}`,
  setting: (key) => `/api/settings/${key}`
});

export function buildApiUrl(path = '', baseUrl = API_BASE_URL) {
  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
}

export const API_CONFIG = Object.freeze({
  baseUrl: API_BASE_URL,
  endpoints: API_ENDPOINTS
});
